import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export enum FlexSectionDirection {
  row = 'row',
  column = 'column'
}

const PaddingThemePropsSchema = z.object({
  bottom: z.number(),
  inlineEnd: z.number(),
  inlineStart: z.number(),
  top: z.number()
});

const PaddingSchema = z.union([z.number(), PaddingThemePropsSchema]);

export const DropShadowSchema = z.object({
  blur: z.number(),
  color: z.string().optional(),
  offsetX: z.number(),
  offsetY: z.number(),
  size: z.number()
});

export const BorderThemePropsSchema = z.object({
  borderColor: z.string().optional(),
  borderWidth: z.number(),
  borderStyle: z.string()
});

export const BorderRadiusThemePropsSchema = z.object({
  topLeft: z.number(),
  topRight: z.number(),
  bottomRight: z.number(),
  bottomLeft: z.number(),
  measureUnit: z.enum([
    '1px',
    '1%',
    // legacy
    'px'
  ])
});

export const FlexSectionWidgetStaticSchema = BaseWidgetSchema(WidgetType.FlexSection).extend({
  layout: z.record(
    z.string(),
    z.object({
      span: z.number().optional().nullable(),
      column: z.number().optional().nullable(),
      height: z.union([z.number(), z.string()]),
      width: z.number(),
      isDeletable: z.boolean(),
      isDraggable: z.boolean()
    })
  ),
  direction: z.nativeEnum(FlexSectionDirection).nullable(),
  style: z.object({
    alignTo: z.string().optional().nullable(),
    backgroundColor: z.string().optional().nullable(),
    backgroundImage: z.string().optional().nullable(),
    backgroundRepeat: z.enum(['no-repeat', 'repeat', 'repeat-x', 'repeat-y']).optional().nullable(),
    backgroundSize: z.enum(['auto', 'cover', 'contain']).optional().nullable(),
    border: BorderThemePropsSchema.optional().nullable(),
    borderRadius: BorderRadiusThemePropsSchema.optional().nullable(),
    dropShadow: DropShadowSchema.optional().nullable(),
    gap: z.number().optional().nullable(),
    isBorderActive: z.boolean().optional().nullable(),
    isDropShadowActive: z.boolean().optional().nullable(),
    padding: PaddingSchema.optional().nullable(),
    paddingBlock: z.number().optional().nullable(),
    paddingInline: z.number().optional().nullable()
  })
});

export type FlexSectionWidgetStaticSchemaType = z.infer<typeof FlexSectionWidgetStaticSchema>;
